<template>
  <div>
    <v-tabs
      v-model="tab"
      color="primary"
      dark
      slider-color="primary"
    >
      <v-tab>
        {{ $$t('list') }}
      </v-tab>
      <v-tab>
        {{ $$t('graph') }}
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <v-data-table
          :headers="headers"
          :items="incidents"
          class="elevation-1"
          :loading="isLoading"
        >
          <template v-slot:item.created="{ item }">
            {{ formatDateTime(item.created) }}
          </template>
          <template v-slot:item.updated="{ item }">
            <span v-if="item.updated">
              {{ formatDateTime(item.updated) }}
            </span>
          </template>
          <template v-slot:item.location="{ item }">
            <MapModal :location="item.location" />
          </template>
          <template v-slot:item.isActive="{ item }">
            <BoolField v-model="item.isActive" />
          </template>
          <template v-slot:item.actions="{ item }">
            <TableBasicButtons
              :item="item"
              :editLink="{ name: 'membership-EditIncident', query: { id: item.id } }"
              @delete="remove(item)"
            />
          </template>
        </v-data-table>
      </v-tab-item>
      <v-tab-item>
        <incidents-map :incidents="incidents" :currentCoords="currentCoords" />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import {
  mdiCancel, mdiCheckCircleOutline, mdiDelete, mdiPencil,
} from '@mdi/js';
import BoolField from '@codehq/aurora-app-core/src/components/BoolField.vue';
import loading from '@codehq/aurora-app-core/src/mixins/loading';
import location from '../mixins/location';
import MapModal from '../components/MapModal.vue';
import IncidentsMap from '../components/IncidentsMap.vue';

export default {
  name: 'ListIncident',
  module: 'Incident',
  components: {
    BoolField,
    MapModal,
    IncidentsMap,
  },
  mixins: [loading, location],
  data() {
    return {
      mdiCancel,
      mdiCheckCircleOutline,
      mdiDelete,
      mdiPencil,
      tab: 0,
    };
  },
  computed: {
    /** Vuex states
     */
    ...mapState('incidents', ['incidents']),
    /**
    * Get table column headers
    */
    headers() {
      return [
        {
          text: this.$$t('incidentType'),
          value: 'incidentType',
        },
        {
          text: this.$$t('location'),
          value: 'location',
        },
        {
          text: this.$$t('description'),
          value: 'description',
        },
        {
          text: this.$$t('created'),
          value: 'created',
        },
        {
          text: this.$$t('createdBy'),
          value: 'createdBy',
        },
        {
          text: this.$$t('isActive'),
          value: 'isActive',
        },
        {
          text: this.$$t('updated'),
          value: 'updated',
        },
        {
          text: this.$$t('updatedBy'),
          value: 'updatedBy',
        },
        {
          text: '',
          value: 'actions',
        },
      ];
    },
    currentCoords() {
      if (!this.currentPosition) {
        return { lat: -28, lng: 26 };
      }
      const { coords } = this.currentPosition;
      return {
        lat: coords.latitude,
        lng: coords.longitude,
      };
    },
  },
  async mounted() {
    this.isLoading = true;
    await this.refresh();
    await this.LOAD_incidents();
    this.isLoading = false;
  },
  methods: {
    /** Vuex methods
     */
    ...mapActions('incidents', ['LOAD_incidents', 'DELETE_incident', 'UPDATE_incident']),
    async enable(item) {
      this.isLoading = true;
      const existingItem = this.incidents.find((i) => i.id === item.id);
      existingItem.isActive = true;
      await this.UPDATE_incident(existingItem);
      await this.LOAD_incidents();
      this.isLoading = false;
    },
    async disable(item) {
      this.isLoading = true;
      const existingItem = this.incidents.find((i) => i.id === item.id);
      existingItem.isActive = false;
      await this.UPDATE_incident(existingItem);
      await this.LOAD_incidents();
      this.isLoading = false;
    },
    /** Delete Incident from the collection
     */
    async remove(incident) {
      this.isLoading = true;
      await this.DELETE_incident(incident.id);
      this.isLoading = false;
    },
  },
};
</script>

<docs>
# Incident example

'''js
<Incident />
'''
</docs>
